import React from 'react';
import { Button } from '@sendgrid/ui-components/button';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import FormExpManager from './FormExpManager';
import withProfileInputs from '../containers/withProfileInputs';
import withPackages from '../containers/withPackages';
import { getEmailApiPlan, getMarketingCampaignsPlan } from '../utils/packageHelper';
import Styles from './profileForm.module.scss';

export class ProfileForm extends React.Component {
  componentDidMount() {
    this.props.fetchStatus();
    // Pulled ehawk out of react into index.html where it
    //  is invoked and updates the talon id value. When
    //  using react we were not able to get the updated
    //  input.talon value without a race condition.
    //  https://www.e-hawk.net/support/api.php 12/20/2017
    const talon = document.getElementById('talon');
    this.props.setEhawkTalon(talon);
    this.dispatchEmailMethod(this.props.packages);
  }

  dispatchEmailMethod(packages) {
    if (!packages || !packages.activePackage || packages.activePackage.length === 0) {
      return;
    }
    const selectedMCPlan = getMarketingCampaignsPlan(packages.activePackage);
    const selectedEIPlan = getEmailApiPlan(packages.activePackage);

    // Since every user defaults to free for 30 days its hard to know intent any more
    // this was once based on what type of paid package a user selected while signing up
    if (selectedEIPlan && selectedEIPlan.id === 'sg.ei.free-100.v1'
      && selectedMCPlan && selectedMCPlan.id === 'sg.mc.free.v1'
    ) {
      return;
    }

    if (selectedEIPlan) {
      this.props.toggleIsTransactional();
    }
    if (selectedMCPlan) {
      this.props.toggleIsMarketing();
    }
  }

  render() {
    return (
      <div className={Styles.profileForm}>
        <FormExpManager />
        <div className={Styles.submitButton}>
          <Button
            type="primary"
            onClick={() => this.props.onSave(this.props.profileInputs, this.props.history)}
            data-role="save-button"
            disabled={!this.props.profileInputs.isValidForm}
          >
            Get Started!
          </Button>
        </div>
      </div>
    );
  }
}

ProfileForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  setEhawkTalon: PropTypes.func.isRequired,
  toggleIsTransactional: PropTypes.func.isRequired,
  toggleIsMarketing: PropTypes.func.isRequired,
  profileInputs: PropTypes.shape({
    isValidForm: PropTypes.bool.isRequired,
  }).isRequired,
  fetchStatus: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  packages: PropTypes.shape({
    activePackage: PropTypes.array.isRequired,
    activeIsFree: PropTypes.bool.isRequired,
    packagesLoaded: PropTypes.bool.isRequired,
  }).isRequired,
};

export default withRouter(withPackages(withProfileInputs(ProfileForm)));
